<template>
    <main class="main frame-medium">

        <h2 class="main__headline remove-t-margin">Program</h2>
        <div class="program__days">
            <div v-for="day in days" v-bind:key="day" @click="selectDate(day)" :class="{ 'is-active': isActive(day) }">
                {{ day }}
            </div>
        </div>
        <div class="program__list" >
            <div v-for="item in list" v-bind:key="item.id"  class="program__list__item" :id="`el_${item.id}`">
                <div class="program__list__time">{{ item.time }}
                </div>
                <div class="program__list__title">{{ item.title }}</div>
                <div class="program__list__subtitle">{{ item.subtitle }}</div>
            </div>
        </div>
    </main>
</template>

<script>
    import VueScrollTo from 'vue-scrollto';

    export default {
        name: "Program",
        props: {
            data: Object
        },
        created (){
            const today = (new Date()).toLocaleDateString().replace(/\//g, '.');
            if (this.days && this.days.length > 0) {
                if (this.days.indexOf(today) !== -1) {
                    this.selectedDate = today;
                    const todayTimes = this.list.filter(({begin}) => this.isToday(begin));
                    const time = new Date();
                    todayTimes.forEach(item => {
                        if (time > item.begin) {
                            this.scrollToId = item.id;
                        }
                    })
                } else
                    this.selectedDate = this.days[0];

            }
        },
        mounted() {
            if (this.scrollToId)
                VueScrollTo.scrollTo(`#el_${this.scrollToId}`);
        },
        data() {
            return {
                selectedDate: undefined,
                scrollToId: undefined
            }
        },
        methods: {
            selectDate: function (day) {
                this.selectedDate = day;
            },
            isActive: function (value) {
                return value === this.selectedDate;
            },
            onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            },
            isToday: function  (someDate)  {
                const today = new Date();
                return someDate.getDate() === today.getDate() &&
                    someDate.getMonth() === today.getMonth() &&
                    someDate.getFullYear() === today.getFullYear()
            }
        },
        computed: {
            days: function () {
                if (!this.arrayed) return;
                const result = this.arrayed.map(item => item.timespans && item.timespans.length > 0 ?
                    item.timespans[0].begin : undefined).filter(item => !!item).map(item => new Date(Date.parse(item)))
                    .sort((a,b) => new Date(a) - new Date(b))
                    .map(date => date.toLocaleDateString().replace(/\//g, '.'))
                    .filter(this.onlyUnique);
                return result;
            },
            arrayed: function () {
                if (!this.data) return;
                return Object.keys(this.data).map(key => this.data[key]);
            },
            list: function () {
                const day = this.selectedDate || this.days[0];
                return this.arrayed.filter(item => item.timespans && item.timespans.length > 0)
                    .filter(item => (new Date(Date.parse(item.timespans[0].begin))).toLocaleDateString()
                                        .replace(/\//g, '.') === day)
                    .map(item => {
                        const begin = (new Date(Date.parse(item.timespans[0].begin)));
                        const end = (new Date(Date.parse(item.timespans[0].end)));
                        const beginMinutes = (begin.getMinutes() < 10 ? '0' : '') + begin.getMinutes();
                        const endMinutes = (end.getMinutes() < 10 ? '0' : '') + end.getMinutes();
                        return Object.assign({}, item, {
                            time: begin.getHours() + ':' + beginMinutes + ' - ' + end.getHours() + ':' + endMinutes,
                            begin,
                            end
                        })
                    })
            }
        }
    }
</script>

<style lang="scss">
    @import '../scss/config';

    .program__days {

        display: flex;
        justify-content: space-around;
        align-items: center;

        font-size: 17px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 0.94;
        letter-spacing: normal;

        &.program__days {
            cursor: pointer;

            div {
                padding: 10px;
                color: #606060;

                border-bottom: solid 1px #606060;

                &.is-active {

                    color: color(accent);
                    border-bottom: solid 2px color(accent);
                }
            }
        }


    }

    .program__list {
        padding-bottom: 70px;
        .program__list__item {
            cursor: pointer;
            padding: 15px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            border-bottom: solid 1px #606060;

            .program__list__time {
                font-size: 17px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 0.94;
                letter-spacing: normal;
                color: color(accent);
                padding-bottom: 10px;
            }

            .program__list__title {
                font-size: 17px;
                font-weight: 600;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.29;
                letter-spacing: normal;
                color: #ffffff;
                padding-bottom: 10px;


            }

            .program__list__subtitle {
                font-size: 17px;
                font-weight: normal;
                font-style: italic;
                font-stretch: normal;
                line-height: 1.29;
                letter-spacing: normal;
                color: #ffffff;

            }
        }
    }

</style>
